import {
  createTestListPagination,
  createTestCasesParamsSelector,
  createTestCasesTrendsParamsSelector,
  createTestListSelector,
  createStatusSelector,
} from '../../../common/test-list/selectors';
import { getFiltersParams, getFiltersAsQueryObject } from '../../../rdc/filters/selectors';
import { STORAGE_TESTS_RDC_KEY } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';

const testListStore = (store) => store.apps.analytics.rdc.testHistory.testList;
export const routerLocation = (store) => store.router.location;

export const testListPagination = createTestListPagination(testListStore);
export const testCasesParamsSelector = createTestCasesParamsSelector(
  getFiltersParams,
  testListStore,
);
export const testCasesTrendsParamsSelector = createTestCasesTrendsParamsSelector(
  testCasesParamsSelector,
  testListStore,
);
export const testListSelector = createTestListSelector({
  testListStore,
  testListPagination,
  getFiltersAsQueryObject,
  type: 'rdc',
  productSubArea: TRACKING_SUB_AREA.TEST_HISTORY,
});
export const statusSelector = createStatusSelector(STORAGE_TESTS_RDC_KEY);
